import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';

import { ComboAutocompleteComponent } from "./combo-autocomplete.component";
// import { BsDropdownModule } from 'ngx-bootstrap/dropdown';
// import { MatTooltipModule } from '@angular/material/tooltip';
// import { ButtonModule } from 'primeng/button';
// import { DropdownModule } from 'primeng/dropdown';
import { FormsModule,ReactiveFormsModule } from '@angular/forms';

@NgModule({
  declarations: [ComboAutocompleteComponent],
  imports: [
    CommonModule, 
    MatAutocompleteModule,
    MatFormFieldModule,
    MatInputModule,
    BrowserAnimationsModule,
    FormsModule,
    ReactiveFormsModule],
    // MatTooltipModule,
    // ButtonModule,
    // DropdownModule,
    // BsDropdownModule.forRoot()],
  exports: [
    ComboAutocompleteComponent]
})

export class ComboAutocompleteModule { }